import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import "./category.css";

const ClientCategory = ({ category }) => {
  const navigate = useNavigate();

  return (
    <div className="category relative overflow-hidden border-2 rounded-xl flex flex-col gap-3 items-center">
      <img
        className="w-full h-full"
        src={`${import.meta.env.VITE_IMG_URL}/${category?.icon}`}
        alt=""
      />
      <div className="absolute bottom-0 left-0 z-[3] w-full right-0 p-4">
        <h2 className="text-xl font-bold text-white">{category?.name}</h2>
        <button
          className="rounded-md bg-white text-black mt-2 px-4 py-1 max-[560px]:py-[2px] max-[560px]:px-2 max-[560px]:text-sm max-[560px]:rounded-3xl"
          onClick={() => navigate(`/categories/${category?._id}`)}
        >
          View more
        </button>
      </div>
      <div className="w-full h-full z-[1] absolute inset-0 bg-gradient-to-b from-black/10 via-black/20 to-black/90"></div>
    </div>
  );
};

export default ClientCategory;
